<script setup>
import { ref, computed, watch, getCurrentInstance, onBeforeMount } from 'vue'
import ChemLinks from '@/components/chemical/ChemLinks.vue'
import { getStructureImageUrl, ALERTS_URL, SEARCH_URL, STDIZER_URL, TOXPRINTS_URL } from '@/main'

const proxy = getCurrentInstance().proxy

const props = defineProps({
  chemical: { type: Object, default: null },
  source: {
    type: String,
    validator: (v) => ['webtest', 'search', 'stdizer', 'toxprints', 'chemicals', 'alerts'].includes(v),
    default: 'webtest',
  },
  searchType: { type: String, default: null },
  query: { type: String, default: null },
})

const computedImageUrl = computed(() => {
  if (props.imageUrl) return props.imageUrl

  if (props.source === 'stdizer' && props.chemical?.id)
    return `${STDIZER_URL}/render?smiles=${encodeURIComponent(props.chemical?.smiles)}`

  if (props.source === 'toxprints' && props.chemical?.structure)
    return `${TOXPRINTS_URL}/render?smiles=${encodeURIComponent(props.chemical?.structure)}`

  if (props.source === 'alerts' && props.chemical?.structure)
    return `${ALERTS_URL}/render?smiles=${encodeURIComponent(props.chemical?.structure)}`
  if (!props.searchType) return getStructureImageUrl(props.chemical)

  if (props.searchType === 'SUBSTRUCTURE' || props.searchType === 'SIMILAR' || props.searchType === 'ADVANCED')
    return `${SEARCH_URL}/render/svg?id=${props.chemical?.id}&query=${encodeURIComponent(props.query)}`
  else return `${SEARCH_URL}/render/svg?id=${props.chemical?.id}`
})
</script>

<template>
  <div class="d-flex flex-column justify-content-center align-items-center">
    <v-img
      :src="computedImageUrl"
      :contain="true"
      alt=""
      max-height="16rem"
      max-width="16rem"
    />

    <ChemLinks
      v-if="chemical?.sid"
      :sid="chemical?.sid"
    />
  </div>
</template>
